<template> <!-- OK -->
    <div class="cadastro-container">
        <div class="cadastro-image">
            <img src="../assets/quadra-radio.jpg" alt="Tennis Court">
        </div>
        <Register/>
    </div>
</template>


<script>
import Register from '../components/Register.vue';

export default {
    name: 'Cadastro',
    components: {
        Register
    }
}

</script>

<style scoped>

    .cadastro-container{
        display: flex;
        align-items: center;
        justify-content: center;
        min-height: 100vh;
        background-color: #FFF;
    }

    .cadastro-image {
        width: 30%;
        height: 100vh;
    }

    .cadastro-image img{
        width: 100%;
        height: 100%;
        object-fit: cover;
    }

    @media (max-width: 425px){
        .cadastro-container{
            flex-direction: column;
        }

        .cadastro-image{
            display: none;
        }
    }


</style>